/**
 * useReceivedInvitesCount
 * Single source for "received invite" counts (friend + group).
 * Uses GET /invitations/counts so the tab bar and Friends/Create do not fetch full friends/groups lists.
 * Always returns numbers (0 when loading or error).
 */

import { useMemo } from 'react';
import { useInvitationCountsQuery } from './useInvitationCountsQuery';

export interface ReceivedInvitesCount {
  friendReceived: number;
  groupReceived: number;
  total: number;
}

export function useReceivedInvitesCount(): ReceivedInvitesCount {
  const { data, isSuccess } = useInvitationCountsQuery();

  return useMemo(() => {
    const friendReceived = isSuccess && data ? data.friendReceived : 0;
    const groupReceived = isSuccess && data ? data.groupReceived : 0;
    return {
      friendReceived,
      groupReceived,
      total: friendReceived + groupReceived,
    };
  }, [isSuccess, data]);
}
